import React__default from 'react';
import c from 'classnames';
import range from 'lodash/range';
import Stack from '../../Stack/Stack.js';
import useLayouts from './hooks/useLayouts.js';
import NumberRatingItem from './NumberRatingItem/index.js';

// libs
var NumberRating = function NumberRating(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$max = props.max,
    max = _props$max === void 0 ? 5 : _props$max,
    onChange = props.onChange,
    value = props.value;
  var _useLayouts = useLayouts(),
    containerLayout = _useLayouts.containerLayout,
    itemLayout = _useLayouts.itemLayout,
    onLayoutContainer = _useLayouts.onLayoutContainer,
    onLayoutItem = _useLayouts.onLayoutItem;
  return /*#__PURE__*/React__default.createElement(Stack, {
    alignItems: "center",
    className: className,
    onLayout: onLayoutContainer
  }, range(1, max + 1).map(function (rating, index, arr) {
    var _itemLayout$width;
    return /*#__PURE__*/React__default.createElement(NumberRatingItem, {
      key: rating,
      className: c(
      // space-x style does not work with native :(
      {
        'me-12': index !== arr.length - 1
      },
      // space-y style does not work with native :(
      {
        'mb-8': (containerLayout == null ? void 0 : containerLayout.width) < (itemLayout == null ? void 0 : itemLayout.width) * max && Math.round((containerLayout == null ? void 0 : containerLayout.width) / ((_itemLayout$width = itemLayout == null ? void 0 : itemLayout.width) != null ? _itemLayout$width : 1)) < index + 1
      }),
      selected: rating === value,
      value: rating,
      onChange: onChange,
      onLayout: onLayoutItem
    });
  }));
};
var index = /*#__PURE__*/React__default.memo(NumberRating);

export { index as default };
//# sourceMappingURL=index.js.map
